"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n    width: 100%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SelectionButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionButtonWrapper",
  componentId: "sc-10fasux-0"
})(["width:33.333333%;width:calc(100% / 3);", ";"], _responsiveBreakpoints.default.phone(_templateObject()));

var _default = SelectionButtonWrapper;
exports.default = _default;
module.exports = exports.default;